import { QuoteType } from '@shared/types/quote-type';
import { createAction, props } from '@ngrx/store';
import { Period } from '@shared/types/period';

export const createOrder = createAction(
  '[Cart] Create Order',
  props<{
    quote_type: QuoteType;
    period: Period;
    reference?: string;
    custom_expiration_date?: string;
    opportunity_id?: number;
  }>(),
);

export const createOrderSuccess = createAction('[Cart] Create Order Success', props<{ quote_id: number }>());

export const createOrderFailure = createAction('[Cart] Create Order Failure', props<{ error: any }>());
